// extracted by mini-css-extract-plugin
module.exports = {"bankAccount":"DepositsDetailsModal_bankAccount__alJb9","bankAccountSelector":"DepositsDetailsModal_bankAccountSelector__c9EfN"};